import { gql } from '@apollo/client';

export default gql`
  mutation rejectSpaceInvitation($spaceId: ID!) {
    rejectSpaceInvitation(input: { spaceId: $spaceId }) {
      success
    }
  }
`;
